/**
 * @generated SignedSource<<3a23584e33d737e3b69a3a2eda5c127e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type AccountMenu_triggerQuery$data = {
  readonly csmLiveChat?: {
    readonly " $fragmentSpreads": FragmentRefs<"LiveConversationsActivityStatusIndicator_query">;
  } | null;
  readonly jira_projectByIdOrKey?: {
    readonly projectType: JiraProjectType | null;
  } | null;
  readonly " $fragmentType": "AccountMenu_triggerQuery";
};
export type AccountMenu_triggerQuery$key = {
  readonly " $data"?: AccountMenu_triggerQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"AccountMenu_triggerQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "projectIdOrKey"
    },
    {
      "kind": "RootArgument",
      "name": "shouldFetchCSMLiveChatAgent"
    },
    {
      "kind": "RootArgument",
      "name": "shouldFetchProjectType"
    }
  ],
  "kind": "Fragment",
  "name": "AccountMenu_triggerQuery",
  "selections": [
    {
      "condition": "shouldFetchProjectType",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            },
            {
              "kind": "Variable",
              "name": "idOrKey",
              "variableName": "projectIdOrKey"
            }
          ],
          "concreteType": "JiraProject",
          "kind": "LinkedField",
          "name": "jira_projectByIdOrKey",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "projectType"
            }
          ]
        }
      ]
    },
    {
      "condition": "shouldFetchCSMLiveChatAgent",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "fragment": {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "LiveConversationsActivityStatusIndicator_query"
              }
            ],
            "type": "Query"
          },
          "kind": "AliasedInlineFragmentSpread",
          "name": "csmLiveChat"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "6aca099e259b04156271c6c33466a5f6";

export default node;
